import { IOdataField } from './IOdataField';

export class OdataFieldName implements IOdataField {
  private name: string;

  constructor(fieldName: string) {
    this.name = fieldName;
  }

  toFieldString() {
    return this.name;
  };
}
